import angular from 'angular';
import * as R from 'ramda';
import IComplianceAppDataService from './IComplianceApp.data.service';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

// let _upload;

class praDataService extends IComplianceAppDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'pra');
    // _upload = Upload;

    /**
     * @deprecated Use the shared model service for cached calls which uses cacheManager
     */
    this.cache = {};
    console.log('app.services.bcpDataService created');
  }

  // ///////////// BCP App ///////////////////
  initApp() {
    return this.$http({
      url: `${this.apiRootUrl}/pra/policyRiskAssessment/init`,
      method: 'GET',
    });
  }

  getSettings() {
    return this.$http({
      url: `${this.apiRootUrl}/pra/policyRiskAssessment/settings`,
      method: 'GET',
    });
  }

  saveSettings(settings) {
    if (!settings) {
      return Promise.resolve();
    }
    return this.$http({
      url: `${this.apiRootUrl}/pra/policyRiskAssessment/settings`,
      method: 'PUT',
      data: JSON.stringify(settings),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // ///////////// Assessment ///////////////////
  getAssessments() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment`,
      method: 'GET',
    });
  }

  getAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}`,
      method: 'GET',
    });
  }

  getAssessmentStatus(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/status`,
      method: 'GET',
    });
  }

  allowNewAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/allowNew`,
      method: 'GET',
    });
  }

  checkAssessmentExists(name, assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/checkExists`,
      method: 'GET',
      params: {
        name,
        id: assessmentId,
      },
    });
  }

  saveAssessment(assessment) {
    if (assessment.assessmentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/pra/assessment/${assessment.assessmentId}`,
        method: 'PUT',
        data: this.serializeData(assessment),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment`,
      method: 'POST',
      data: this.serializeData(assessment),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveNotifications(assessmentId, assessmentNotifications = []) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/notification/saveList`,
      method: 'POST',
      data: JSON.stringify(assessmentNotifications),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}`,
      method: 'DELETE',
    });
  }

  canBoardApprove(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/canApprove`,
      method: 'GET',
    });
  }

  approveAssessment(assessmentId, approvedById, approvalDate) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/boardApproved`,
      method: 'PUT',
      data: this.serializeData({
        approvedById,
        approvalDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  unapproveAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/unapprove`,
      method: 'PUT',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  auditedBy(assessmentId, auditedBy, auditDate) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/auditedBy`,
      method: 'PUT',
      data: this.serializeData({
        auditedBy,
        auditDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  examinedBy(assessmentId, examinedBy, examineDate) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/examinedBy`,
      method: 'PUT',
      data: this.serializeData({
        examinedBy,
        examineDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  canGenerateDocument(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/canGenerateDocument`,
      method: 'GET',
    });
  }

  canPrioritize(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/canPrioritize`,
      method: 'GET',
    });
  }

  hasIncompleteAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/hasIncompleteAssessment`,
      method: 'GET',
    });
  }

  // ///////////// Process ////////////////////
  getProcessByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentId}`,
      method: 'GET',
    });
  }

  getProcessAssignedAssets(assessmentProcessId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/assignedAssets`,
      method: 'GET',
    });
  }

  getProcessAssetsByType(assessmentProcessId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/groupAssetsByType`,
      method: 'GET',
    });
  }

  saveAssessmentProcesses(assessmentId, assessmentProcess, submit) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentId}`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcess),
      params: {
        echo: true,
        submit
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getAssignedAssetsByProcess(assessmentProcessId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcessCustomerAsset/${assessmentProcessId}`,
      method: 'GET',
    });
  }

  getAssetsByAssetType(assessmentProcessId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/groupAssetsByType`,
      method: 'GET',
    });
  }

  getAssetsByAssetTypeId(assessmentProcessId, assetTypeId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/getAssetsByType/${assetTypeId}`,
      method: 'GET',
    });
  }

  assignAssetsToProcess(assessmentProcessId, assetIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/assignAssets`,
      method: 'PUT',
      data: JSON.stringify(assetIds),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  unassignAssetFromProcess(assessmentProcessId, customerAssetId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/removeAssessmentCustomerAssetByCustomerAsset/${customerAssetId}`, // eslint-disable-line
      method: 'PUT',
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  transformAssignedAssets(assignedAssets, assetTypes) {
    if (assignedAssets && assignedAssets.length > 0) {
      const allAssignedAssets = [];
      R.forEach(
        (asset) => {
          const find = R.find(
            R.propEq('customerAssetTypeId', asset.customerAssetTypeId),
            assetTypes
          );
          if (find) {
            asset.customerAssetType = find;
          }

          allAssignedAssets.push(asset);
        },
        assignedAssets
      );
      return allAssignedAssets;
    }
  }

  resetAssessmentProcess(assessmentProcessId) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/${assessmentProcessId}/resetStatus`,
      method: 'PUT',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  bulkResetAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/bulkReset`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveAssessmentProcessThreats(assessmentId, assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/threats/saveList`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getDocumentProcedureByUser(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/documentProcedureForUser`,
      method: 'GET',
    });
  }

  saveDocumentProcedure(assessmentId, assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/saveDocumentProcedureList`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  submitAssessmentProcesses(assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/submit`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcessIds),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  bulkSubmitAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/assessmentProcess/bulkSubmit`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  approveOrDenyProcesses(assessmentProcessApprovals) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessmentProcess/approve`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcessApprovals),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  bulkApproveAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/assessmentProcess/bulkApprove`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  resetAssessmentProcessStatus(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/processImpactAnalysis/resetStatus`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  bulkResetAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/pra/assessment/${assessmentId}/assessmentProcess/bulkReset`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getProcessesToPrioritize(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/prioritize`,
      method: 'GET',
    });
  }

  savePrioritizedProcesses(prioritizedProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/prioritize`,
      method: 'PUT',
      data: this.serializeData({
        prioritizedProcesses: JSON.stringify(prioritizedProcesses),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  /* *****************************************************************************
   *  Department Resources
   */

  getDepartments(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/department`,
      method: 'GET',
    });
  }

  saveDepartments(assessmentDepartments) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDepartment/saveList`,
      method: 'POST',
      data: this.serializeData({
        assessmentDepartments: JSON.stringify(assessmentDepartments),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }
}

praDataService.$inject = [
  '$http',
  'Upload',
  'utilityService'
];

export default angular.module('app.services.praDataService', [
  ngFileUpload,
])
  .service('praDataService', praDataService)
  .name;
